import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  Icon,
  Button,
  Type,
  Size,
  Modal
} from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { LazyLoad } from 'acq-components/lib/services/performance/LazyLoad/LazyLoad';
import { getPdpLinks } from 'page_modules/business-pdp/redux';
import { getCombinedG175Data } from './redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import styles from './__styles__/index.scss?modules';

const ModalBox = ({ title, content, toShow, toggle }) => {
  return (
    <Modal.Container $isOpen={toShow} toggle={toggle} $size={Size.LG}>
      <Modal.Title>{title || ''}</Modal.Title>
      <Modal.Content
        theme={{
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 0,
          paddingBottom: 10
        }}
      >
        <Typography className={styles.modalText}>{content}</Typography>
      </Modal.Content>
    </Modal.Container>
  );
};

const ListItem = ({ header, text, imageName }) => {
  return (
    <div className={styles.listItem}>
      <Icon
        className={styles.listIcon}
        directory="dls"
        hiddenToScreenReaders="true"
        imageName={imageName}
      />
      <div className={styles.listCnotent}>
        <Typography Component="div" className={styles.itemHeader}>
          {header}
        </Typography>
        <Typography Component="div" className={styles.itemText}>
          {text}
        </Typography>
      </div>
    </div>
  );
};

const CmAddEmpBanner = ({ links, needToRenderG175, staticData }) => {
  const [showModel, setShowModal] = useState(false);

  if (!needToRenderG175) {
    return null;
  }

  const {
    header,
    subHeader,
    content = [],
    assets = [],
    dtmEvents = [],
    toolTipModal
  } = staticData;
  const dtmImp = dtmEvents.find(dtm => dtm.key === 'bannerImpression') || {};
  const dtmCta = dtmEvents.find(dtm => dtm.key === 'ctaClick') || {};
  const assetMobile = assets.find(asset => asset.type === 'mobile');
  const assetDesktop = assets.find(asset => asset.type === 'desktop');
  const addEmpLink = links?.addAnEmployee || {};
  const toolTipDtm = {
    ...dtmCta,
    eventAsset: `${dtmCta?.eventAsset}_tooltip`
  };

  const toggleModal = e => {
    e?.stopPropagation();
    setShowModal(!showModel);
  };

  return (
    <React.Fragment>
      <LazyScrollMetricTracker scrollDtm={dtmImp} />
      <div className={styles.cmAddEmpBanner}>
        <LazyLoad offset={500}>
          <picture className={styles.imgHolder}>
            <source media="(max-width: 767px)" srcSet={assetMobile?.url} />
            <source media="(min-width: 768px)" srcSet={assetDesktop?.url} />
            <img srcSet={assetDesktop?.url} alt="" />
          </picture>
        </LazyLoad>
        <div className={styles.contentBox}>
          <Typography Component="h2" className={styles.header}>
            {header}
          </Typography>
          <Typography Component="div" className={styles.subHeader}>
            {subHeader}
          </Typography>
          <div className={styles.listBox}>
            {content.map((item, i) => {
              return <ListItem key={`k${i}`} {...item} />;
            })}
          </div>
          <div className={styles.ctaHolder}>
            <Button
              className={styles.cta}
              Component="a"
              $type={Type.Secondary}
              href={addEmpLink.url}
              onClick={() => sendDTMClickEvent(dtmCta)}
            >
              {addEmpLink.text}
            </Button>
            <button
              className={styles.tooltip}
              title={`${addEmpLink.text} tooltip`}
              onClick={e => {
                e.stopPropagation();
                toggleModal(e);
                sendDTMClickEvent(toolTipDtm);
              }}
            >
              <Icon
                directory="dls"
                imageName="dls-icon-info-tooltip"
                $size={Size.SM}
              />
            </button>
          </div>
          <ModalBox
            content={toolTipModal}
            toShow={showModel}
            toggle={e => toggleModal(e)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  const urlEep = ownProps?.params?.eep || '';
  return {
    ...getCombinedG175Data(state),
    links: getPdpLinks(urlEep)(state)
  };
};

export default connect(mapStateToProps)(React.memo(CmAddEmpBanner));
